module.exports = __webpack_public_path__ + "img/provizor.4f7228b.svg";